import React, { useEffect, useMemo, useState } from "react";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { Badge, BadgeProps, IconButton, Popover, styled } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { useDevice, usePreviousHook } from "hooks";
import { useNotificationsSelector, useUserActions } from "store";

import { List } from "./List/List";

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 4,
    padding: "0 4px",
    backgroundColor: "#26A6AE",
    border: "2px solid white",
    color: "white"
  }
}));

export const Notifications: React.FC = () => {
  const { list: notifications, loading, hasMore, unreadItems, filterByDeal } = useNotificationsSelector();
  const { getNotificationsAction, setFilterByDeal, clearCounter } = useUserActions();
  const { isMobile } = useDevice();

  const [isWatched, setIsWatched] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const lengthPrevious: number = usePreviousHook(notifications.length);

  useEffect(() => {
    if (notifications.length > lengthPrevious) {
      setIsWatched(false);
    }
  }, [notifications.length]);

  const badgeQuantity = useMemo(() => {
    if (anchorEl) return 0;
    if (isWatched) return 0;
    return unreadItems;
  }, [unreadItems, isWatched, anchorEl]);

  return (
    <>
      <MaterialTooltip title="Notifications" isShow>
        <IconButton
          onClick={(e) => {
            setAnchorEl(e.currentTarget);
            setIsWatched(true);
            if (unreadItems) {
              clearCounter();
            }
          }}
        >
          <StyledBadge max={99} showZero={false} badgeContent={badgeQuantity}>
            <NotificationsNoneIcon sx={{ fontSize: "24px", color: anchorEl ? "#26A6AE" : "#0A3142" }} />
          </StyledBadge>
        </IconButton>
      </MaterialTooltip>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: isMobile ? "right" : "left" }}
        transformOrigin={{ vertical: "top", horizontal: isMobile ? "right" : "left" }}
      >
        <List
          loading={loading}
          hasMore={hasMore}
          getNext={getNotificationsAction}
          closeList={() => setAnchorEl(null)}
          notifications={notifications}
          filterByDeal={filterByDeal}
          setFilterByDeal={setFilterByDeal}
        />
      </Popover>
    </>
  );
};
